import { createSlice } from '@reduxjs/toolkit';
import { api } from './apiSlice'

export const billingApiSlice = api.injectEndpoints({
    endpoints: build => ({
        getInvoicesByListingId: build.query({
            query: (listingId) => `marketplace/billing/invoices/listing/${listingId}`,
            providesTags: ['InvoicesByListing'],
            method: 'GET',
        }),
        getInvoiceDetailsByInvoiceId: build.query({
            query: (invoiceId) => `marketplace/billing/invoice/details/${invoiceId}`,
            providesTags: ['InvoiceDetails'],
            method: 'GET',
        }),
        getCurrentDetailsByPartnerListingId: build.query({
            query: (partnerListingId) => `marketplace/billing/current/details/${partnerListingId}`,
            providesTags: ['CurrentDetails'],
            method: 'GET',
        }),
        getBillingTermsByListingId: build.query({
            query: (listingId) => `marketplace/billing/terms/listing/${listingId}`,
            providesTags: ['BillingTerms'],
            method: 'GET',
        }),
        getBillingSubscriptionIdByPartnerListingId: build.query({
            query: (listingId) => `marketplace/billing/subscription/listing/${listingId}`,
            providesTags: (result, error, listingId) => [
                { type: 'ShopifyBillingSubscription', id: listingId },
            ],
            method: 'GET'
        }),
        syncShopifyBillingSubscription: build.mutation({
            query: ({ billingSubscriptionId, partnerId, partnerListingId, shopifyUrl }) => ({
                url: 'marketplace/billing/subscription/sync/shopify',
                method: 'POST',
                body: {
                    ShopifyBillingSubscription: {
                        BillingSubscriptionId: billingSubscriptionId.billingSubscriptionId,
                        PartnerId: partnerId,
                        PartnerListingId: partnerListingId,
                        ShopifyUrl: shopifyUrl,
                    }
                },
            }),
            invalidatesTags: (result, error, { partnerListingId }) => [
                { type: 'ShopifyBillingSubscription', id: partnerListingId }
            ],
        }),
        setInvoicePaymentProfileOverride: build.mutation({
            query: ({ invoiceId, paymentType }) => ({
                url: `marketplace/billing/invoice/${invoiceId}/payment-profile-override`,
                method: 'POST',
                body: { PaymentType: paymentType },
            }),
            invalidatesTags: (result) => result?.success ? ['InvoicesByListing'] : [],
        }),
    })
})

const initialState = [];
const billingSlice = createSlice({
    name: 'billingNew',
    initialState,
    reducers: {},
})

export const {
    useGetInvoicesByListingIdQuery,
    useGetInvoiceDetailsByInvoiceIdQuery,
    useGetCurrentDetailsByPartnerListingIdQuery,
    useLazyGetInvoiceDetailsByInvoiceIdQuery,
    useGetBillingTermsByListingIdQuery,
    useGetBillingSubscriptionIdByPartnerListingIdQuery,
    useSyncShopifyBillingSubscriptionMutation,
    useSetInvoicePaymentProfileOverrideMutation,
} = billingApiSlice;

export default billingSlice.reducer;
